import { DateTimeLocalizationInfo, TimeService } from '@mews/framework';

const EARLIEST_TIME = '00:00:00';
const LATEST_TIME = '23:59:59';

export const earliestDayTime = TimeService.parse(EARLIEST_TIME);
export const latestDayTime = TimeService.parse(LATEST_TIME);

export const getEarliestDayTime = (localizationInfo: DateTimeLocalizationInfo) =>
    TimeService.toShortString(earliestDayTime, localizationInfo);

export const getLatestDayTime = (localizationInfo: DateTimeLocalizationInfo) =>
    TimeService.toShortString(latestDayTime, localizationInfo);
